import React, { useState } from "react";
import { Spinner } from "reactstrap";
import Sparkle from "@workspace/main/src/assets/images/sparkle.png";
import { InputGroup, InputGroupText, InputGroupAddon, Input } from "reactstrap";
import { useEffect } from "react";

const LLMQuestionInput = ({ onGetAnswer, isLoading, value, setQuestion }) => {
  const [inputValue, setInputValue] = useState(
    value ||
      `You are an AI specialized in generating interview questions tailored to a specific job description. 
    Based on the provided job description:
    {job_description}
    
    1) Generate {no} unique and relevant interview questions that assess the candidate's skills, experience, and suitability for the role.
    2) Ensure the questions are clear, concise, and aligned with the responsibilities and qualifications mentioned in the job description.
    3) Do not generate any question that is identical, similar in phrasing, or overlaps in meaning with the questions already generated. Each question must be entirely unique, addressing a different skill, experience, or responsibility from the job description, without repeating or rephrasing concepts covered in previous questions.
    `
  );

  // initalizeData(inputValue)
  useEffect(() => {
    if (!value) {
      setQuestion(inputValue);
    }
  }, [value]);

  return (
    <div>
      <InputGroup style={{ position: "relative", marginBottom: "15px" }}>
        <InputGroupText
          style={{
            background: "transparent",
            border: "1px solid #f3f3f3",
            borderRight: "0px solid transparent",
          }}
        >
          <div className="mapping-ai">
            <div className="mapping-ai-inner">
              <img src={Sparkle} style={{ width: "12px" }} />
            </div>
          </div>
        </InputGroupText>
        <Input
          type="textarea"
          style={{
            border: "1px solid #f3f3f3",
            borderLeft: "0px solid transparent",
            paddingLeft: "0px",
            paddingRight: "40px", // Add this to ensure text doesn't overlap with the icon
            borderRadius: "5px",
          }}
          placeholder="Enter.."
          value={value || inputValue}
          onChange={(e) => {
            setInputValue(e.target.value);
            setQuestion(e.target.value);
          }}
        />
        <span
          className="d-flex justify-content-center align-items-center"
          style={{
            position: "absolute",
            right: "40px",
            transform: "translateY(-50%)",
            top: "50%",
            cursor: "pointer",
            fontSize: "15px",
            zIndex: "1000",
            width: "30px",
            height: "30px",
            borderRadius: "50%",
            border: "1px solid black",
          }}
          onClick={async () => onGetAnswer(inputValue)}
        >
          {isLoading ? (
            <Spinner size="sm" color="primary" />
          ) : (
            <i className="mdi mdi-arrow-left-bottom" />
          )}
        </span>
      </InputGroup>
    </div>
  );
};

export default LLMQuestionInput;
